export const config = [
  {
    id: 'tour-overview',
    name: 'Trip Overview',
    showTourHeader: true,
    renderMethod: 'renderTourOverviewTab',
    dataTest: 'navtab-overview',
  },
  {
    id: 'extras',
    name: 'Extras',
    showTourHeader: true,
    renderMethod: 'renderExtrasTab',
    dataTest: 'navtab-extras',
  },
  {
    id: 'passengers',
    name: 'Passengers',
    showTourHeader: false,
    renderMethod: 'renderPassengersTab',
    dataTest: 'navtab-passengers',
  },
  {
    id: 'payment',
    name: 'Book',
    showTourHeader: false,
    renderMethod: 'renderPaymentTab',
    loadMethod: 'loadPaymentTab',
    unloadMethod: 'unloadPaymentTab',
    navigableMethod: 'paymentTabNavigable',
    bookingCreated: true,
    dataTest: 'navtab-payment',
  },
  {
    id: 'confirmation',
    name: 'Booking Confirmed',
    renderMethod: 'renderConfirmationTab',
    loadMethod: 'loadConfirmationTab',
    navigableMethod: 'confirmationTabNavigable',
    bookingCreated: true,
    dataTest: 'navtab-confirmation',
  },
]

const getDefaultTabName = tabId => config.find(x => x.id === tabId).name

export const getTabName = (brandName, tabId) => {
  switch (brandName) {
  case 'Trafalgar':
    switch (tabId) {
    case 'passengers':
      return 'Passenger Details'
    default:
      return getDefaultTabName(tabId)
    }
  case 'Contiki':
    switch (tabId) {
    case 'passengers':
      return 'Passenger Details'
    case 'payment':
      return 'Payment'
    case 'extras':
      return 'Extras'
    default:
      return getDefaultTabName(tabId)
    }
  case 'Insight Vacations':
    switch (tabId) {
    case 'confirmation':
      return 'Confirmation'
    default:
      return getDefaultTabName(tabId)
    }
  default:
    return getDefaultTabName(tabId)
  }
}
